import { fetchAPI } from "../../utils/FetchApi";
import { FetchMethods } from "../../interface/Enums/methods.enum";
import { IEvaluationPeriod } from "../../interface";

//[Nest] 76208  - 08/05/2025, 10:02:56 AM     LOG [RouterExplorer] Mapped {/admincmds/get-all-evaluation-periods/:country, GET} route +0ms
export const getAllEvaluationPeriods = async (selectedCountry: string) => {
  try {
    const data: IEvaluationPeriod[] | any = await fetchAPI(
      `/admincmds/get-all-evaluation-periods/${selectedCountry}`,
      FetchMethods.GET
    );
    if (data.hasOwnProperty("error")) {
      throw new Error(data.message?.toString());
    }
    return data;
  } catch (error: any) {
    throw new Error(error.toString());
  }
}

//[Nest] 76208  - 08/05/2025, 10:02:56 AM     LOG [RouterExplorer] Mapped {/admincmds/get-all-non-expired-evaluation-periods/:country, GET} route +0ms
export const getAllNonExpiredEvaluationPeriods = async (selectedCountry: string) => {
  try {
    const data: IEvaluationPeriod[] | any = await fetchAPI(
      `/admincmds/get-all-non-expired-evaluation-periods/${selectedCountry}`,
      FetchMethods.GET
    );
    if (data.hasOwnProperty("error")) {
      throw new Error(data.message?.toString());
    }
    return data;
  } catch (error: any) {
    throw new Error(error.toString());
  }
}